/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CountBubble/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CountBubble({
  children,
  viewPath = "/DesignSystem/CountBubble",
  backgroundColor = "rgba(0,0,0,0.6)",
  paddingLeft = 8,
  paddingRight = 8,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  position,
  top,
  right,
  size,
  color = "white",
  text
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="CountBubble.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1oET2f': backgroundColor,'--pl-2-Z1oET2f': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-3-Z1oET2f': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--ml-6-Z1oET2f': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-7-Z1oET2f': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-8-Z1oET2f': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--p-9-Z1oET2f': position,'--t-10-Z1oET2f': typeof top === 'number' ? `${top}px` : top,'--r-11-Z1oET2f': typeof right === 'number' ? `${right}px` : right,'--w-5-Z1oET2f': size == "small" ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : size == "normal" ? "16px" : "16px",'--h-4-Z1oET2f': size == "small" ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : size == "normal" ? "16px" : "16px"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={-1}
 marginLeft={-0.5}
 size="small"
 color={color}
 text={text}
/>
</div>
{children}
</React.Fragment>)
}